import {
    IDisabledBtn
} from '../actions/disabled-delete-button';
import { IBillingState } from '../state';

export const disabledDeleteIcon =
    (state: IBillingState, action: IDisabledBtn) => {
        return {
            ...state,
            disabledDeleteIcon: action.data
        }
    }
